<vtr-page-layout [title]="'common.menu.dashboard' | translate" [back]="'common.ui.back' | translate"
	backId="dashboard-back-btn" [textId]="'dashboard'" [pageCssClass]="'dashboard'" [shiftLeftUp]="true"
	[shiftRightUp]="true">

	<left-content>
		<div class="container-fluid">
			<div class="row">
				<vtr-widget-offline-tip class="col-sm-12 p-0 mb-24" *ngIf="!isOnline"></vtr-widget-offline-tip>
				<div class="col-sm-12 pb-20 pt-0 px-0">
					<vtr-widget-about-my-device></vtr-widget-about-my-device>
				</div>
				<div class="col-12 px-0 d-flex custom-card-container">
					<div class="custom-card pb-20 card-left" [hidden]="isQuickSettingsHidden" *ngIf="hasQuickSettings">
						<div class="row" *ngIf="hardwareSettingsAvailable">
							<div class="col-sm-12 px-0">
								<vtr-widget-quicksettings
									(quickSettingsDeviceAvailability)="setQuickSettingsAvailability($event)"
									[vtrAppSearchScroller]="['search-microphone-quick', 'search-camera-quick', 'search-eye-care-quick']">
								</vtr-widget-quicksettings>
							</div>
						</div>
					</div>
					<div class="custom-card pb-20">
						<vtr-widget-common-warranty *ngIf="deviceService.showWarranty"
							[warrantyData]="warrantyData"
							[isOnline]="isOnline"
							[title]=" 'dashboard.systemStatus.warranty.title' |translate">
						</vtr-widget-common-warranty>
					</div>
				</div>
			</div>
		</div>
	</left-content>

	<right-content>
		<div class="container-fluid">
			<div class="row" *ngIf="isGiveFeedbackVisible">
				<div class="col-sm-12 col-md-12 pb-20 px-0">
					<vtr-widget-feedback (visibilityChange)="onFeedbackVisibiltyChange($event)"></vtr-widget-feedback>
				</div>
			</div>
			<div class="row" *ngIf="isShowSystemUpdateWidget()">
				<div class="col-sm-12 col-md-12 pb-20 px-0">
					<vtr-widget-system-update></vtr-widget-system-update>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 px-0">
					<vtr-widget-storage-status [memoryDiskUsage]="memoryDiskUsage">
					</vtr-widget-storage-status>
				</div>
			</div>
		</div>
	</right-content>

	<!--indicate dashboard was loaed, send related metrics-->
	<div vtrPageLoadedDetector></div>

</vtr-page-layout>
